<template>
  <article class="pending-wrapper">
    <section class="pending-container">
      <pending-header />
      <component
        v-bind:is="currentTabComponent"
        @showTooltip="onShowTooltip"
        @hideTooltip="onHideTooltip"
      ></component>
    </section>
    <fullscreen-modal />
    <modal />
    <notification />
  </article>
</template>
<script>
import { mapState } from 'vuex';

import FullscreenModal from '@/components/atoms/FullscreenModal';
import Modal from '@/components/atoms/Modal';
import Notification from '@/components/atoms/Notification';
import PendingHeader from '@/components/organisms/PendingHeader';
import PendingStatusChanges from '@/components/templates/PendingStatusChanges';
import PendingLineups from '@/components/templates/PendingLineups';
import PendingReplacements from '@/components/templates/PendingReplacements';
import PendingReplacementsNew from '@/components/templates/PendingReplacementsNew';

export default {
  name: 'Pending',
  components: {
    PendingHeader,
    PendingStatusChanges,
    PendingLineups,
    PendingReplacements,
    PendingReplacementsNew,
    FullscreenModal,
    Modal,
    Notification,
  },
  computed: {
    ...mapState({
      tab: (state) => state.pending.tab,
    }),
    currentTabComponent() {
      return `pending-${this.tab}`;
    },
  },
  methods: {
    onShowTooltip(...args) {
      this.$emit('showTooltip', ...args);
    },
    onHideTooltip() {
      this.$emit('hideTooltip');
    },
    erasePendingData(to) {
      if (to.name !== 'pendingFundsUndoChanges') {
        // Retain Client selection for Undo Changes page.
        this.$store.dispatch('setPendingClient', {
          listVisible: false,
          name: 'All Clients',
          code: '',
          selected: 0,
        });
      }

      this.$store.dispatch('setPendingItemsSelected', {
        list: [],
        total: 0,
      });
      this.$store.dispatch('setPendingTab', 'status-changes');
      this.$store.dispatch('closeNotification');
      this.$store.dispatch('setSearchTerm', '');
    },
  },
  beforeRouteLeave(to, from, next) {
    this.erasePendingData(to, from);
    next();
  },
};
</script>
<style lang="scss">
.pending-container {
  display: flex;
  flex-direction: column;
}
.pending-wrapper {
  width: calc(100% - 85px);
}
</style>
